/**
 * TypedTextFileModal — type free text into a pop-up and save it as a .txt
 * attachment. Used by required-document slots whose content is prose (the
 * treating therapist statement) so a few sentences don't force anyone to
 * produce a document out-of-band. "Attach a file instead" falls back to the
 * normal OS picker for signed / scanned statements.
 */

import React, { useState } from 'react';

export default function TypedTextFileModal({
  title, placeholder, saving = false, onSave, onChooseFile, onClose,
}) {
  const [text, setText] = useState('');
  const ready = text.trim().length > 0;

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-label={title}
      style={overlayStyle}
      onMouseDown={(e) => { if (e.target === e.currentTarget && !saving) onClose(); }}
    >
      <div style={dialogStyle}>
        <div style={{ fontSize: 15, fontWeight: 600, marginBottom: 4 }}>{title}</div>
        <div style={{ fontSize: 12, color: 'var(--text-3)', marginBottom: 12 }}>
          Type it below — it is saved to the case as a text document. If you
          already have it as a document or photo, attach that instead.
        </div>
        <textarea
          className="textarea"
          autoFocus
          style={{ minHeight: 160, fontSize: 13, width: '100%' }}
          placeholder={placeholder}
          value={text}
          onChange={(e) => setText(e.target.value)}
          disabled={saving}
        />
        <div style={{ display: 'flex', gap: 8, marginTop: 14, alignItems: 'center', flexWrap: 'wrap' }}>
          <button type="button" className="btn ghost" onClick={onClose} disabled={saving}>Cancel</button>
          <span style={{ flex: 1 }} />
          <button type="button" className="btn" onClick={onChooseFile} disabled={saving}>
            Attach a file instead…
          </button>
          <button
            type="button"
            className="btn primary"
            disabled={!ready || saving}
            onClick={() => onSave(text.trim())}
          >
            {saving ? 'Saving…' : 'Save'}
          </button>
        </div>
      </div>
    </div>
  );
}

const overlayStyle = {
  position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.35)',
  display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 400,
};
const dialogStyle = {
  background: 'var(--surface)', border: '1px solid var(--border)',
  borderRadius: 12, boxShadow: '0 12px 40px rgba(0,0,0,0.18)',
  padding: 20, width: 'min(560px, calc(100vw - 32px))',
};
